import { render, staticRenderFns } from "./LandingBuilder.vue?vue&type=template&id=39b56107"
import script from "./LandingBuilder.vue?vue&type=script&lang=js"
export * from "./LandingBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports